module.exports = __webpack_public_path__ + "static/media/logoorange.24f7fa11.png";